import { useReactiveVar } from '@apollo/client'
import { Button } from '@radix-ui/themes'
import { DataTestIDs } from 'shared/constants'
import { RadixText } from 'shared/ui'
import { useAuthSession } from '../hooks/use-auth-session'
import { isPrivyExchangingVar, isPrivyReadyVar } from '../store'

/**
 * Header entry point for the Privy flow: opens the Privy login modal.
 * The full login screen with its own branding is FE-302.
 */
export const PrivySignInButton = () => {
  const isReady = useReactiveVar(isPrivyReadyVar)
  const isExchanging = useReactiveVar(isPrivyExchangingVar)
  const { signIn } = useAuthSession()

  return (
    <Button
      onClick={signIn}
      disabled={!isReady || isExchanging}
      my={'0'}
      mx={'2'}
      size={'3'}
      color={'yellow'}
      type={'button'}
      data-testid={DataTestIDs.buttonPrivySignIn}
    >
      <RadixText
        weight={'bold'}
        size={'2'}
      >
        {isExchanging ? 'Signing in...' : 'Sign in'}
      </RadixText>
    </Button>
  )
}
